"use client";
import React, { useEffect, useState } from "react";
import { faShareAlt } from "@fortawesome/pro-solid-svg-icons";

import Button from "@/components/button";
import { Animation, GetAnimationQuery } from "@/gql/generated/graphql";

export const ShareButton = ({ animation }: { animation: GetAnimationQuery['animation'] }) => {
  const [lazyRender, setLazyRender] = useState(false);
  const canShare = typeof navigator !== "undefined" && !!navigator.share;

  useEffect(() => {
    setLazyRender(true);
  }, []);

  if (!canShare || !lazyRender || !animation) return null;

  const onShareClicked = () => {
    navigator
      .share({
        title: `${animation.title} - by ${animation.user.name}`,
        url: `https://theanimator.co.uk/animation/${animation.url}`,
      })
      .catch(() => {
        // ignore
      });
  };

  return (
    <Button icon={faShareAlt} onClick={onShareClicked} type="positive">
      Share
    </Button>
  );
};